import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type Location, type PaxCount } from '@utils/types';

export type UrlStringParams<T> = {
    [k in keyof T]?: string;
};

export enum SearchFromErrorMessage {
    DuplicatePath = 'DuplicatePath',
}

export interface LocationGroup<T extends Location<T> = Location> {
    title: string | null;
    locations: T[];
    icon?: IconDefinition;
    ignoreGroupInSearch?: boolean;
}
export type PaxModel = {
    title?: string;
    deleteAble?: boolean;
    paxList: PaxCount[];
};

export type dayChangerFunc = (params: { query: any; path: string }) => void;
